import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079529fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PVZForm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex items-center justify-between PVZFormHeader" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex items-center mt-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt mr-2" }, null, -1))
const _hoisted_12 = { class: "flex items-center mt-1" }
const _hoisted_13 = { class: "PVZFormFooter flex items-center justify-end mt-6" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex items-center justify-between PVZFormHeader" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_17 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_18 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_time = _resolveComponent("the-time")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_geocoder = _resolveComponent("geocoder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.geocode_state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_page_title, { title: _ctx.modalTitle }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isUpdate)
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    class: "red text small",
                    loading: _ctx.state.is_loading,
                    onClick: _ctx.onDeletePVZ
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createTextVNode("Удалить ПВЗ ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_the_button, {
                class: "second text small",
                disabled: _ctx.state.is_loading,
                onClick: _ctx.emitCancel
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Отмена ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.isAddUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_the_select, {
                    value: _ctx.state.user_id,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.user_id) = $event)),
                    placeholder: "Выберите пользователя",
                    loading: _ctx.data_state.users.is_loading,
                    options: _ctx.data_state.users.list,
                    failed: _ctx.data_state.users.is_failed,
                    "is-invalid": _ctx.state_form$.user_id.$error,
                    "validation-errors": _ctx.state_form$.user_id.$errors,
                    "error-text": "При получении списка пользователей произошла ошибка",
                    "search-by": "email",
                    "select-by": "id",
                    label: "email",
                    "infinite-scroll": "",
                    onRefresh: _ctx.refreshUsers,
                    onLoadmore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMoreUsers(_ctx.data_state.users.pagination.current_page + 1))),
                    onSearch: _ctx.searchUser,
                    onOptionBySearch: _ctx.unshiftFindedUser,
                    class: "mt-3"
                  }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_the_input, {
                    class: "mt-3",
                    placeholder: "Название ПВЗ",
                    "is-invalid": _ctx.state_form$.name.$error,
                    "validation-errors": _ctx.state_form$.name.$errors,
                    value: _ctx.state.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.name) = $event))
                  }, null, 8, ["is-invalid", "validation-errors", "value"]),
                  _createVNode(_component_the_input, {
                    class: "mt-1",
                    placeholder: "Телефон",
                    "is-invalid": _ctx.state_form$.phone.$error,
                    "validation-errors": _ctx.state_form$.phone.$errors,
                    value: _ctx.state.phone,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.phone) = $event)),
                    maska: _ctx.PHONE_NUMBER_MASK
                  }, null, 8, ["is-invalid", "validation-errors", "value", "maska"]),
                  _createVNode(_component_the_select, {
                    value: _ctx.state.city_id,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.city_id) = $event)),
                    placeholder: "Выберите город",
                    loading: _ctx.data_state.cities.is_loading,
                    options: _ctx.data_state.cities.list,
                    failed: _ctx.data_state.cities.is_failed,
                    "is-invalid": _ctx.state_form$.city_id.$error,
                    "validation-errors": _ctx.state_form$.city_id.$errors,
                    "error-text": "При получении списка городов произошла ошибка",
                    "search-by": "name",
                    "select-by": "id",
                    label: "name",
                    "infinite-scroll": "",
                    onRefresh: _ctx.refreshCities,
                    onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
                    onSearch: _ctx.searchUser,
                    onOptionBySearch: _ctx.unshiftFindedCity,
                    onChange: _ctx.onCitySelect,
                    class: "mt-3"
                  }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch", "onChange"]),
                  _createVNode(_component_the_select, {
                    value: _ctx.state.company_id,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.company_id) = $event)),
                    placeholder: "Выберите компанию для ПВЗ",
                    loading: _ctx.data_state.companies.is_loading,
                    options: _ctx.data_state.companies.list,
                    failed: _ctx.data_state.companies.is_failed,
                    "is-invalid": _ctx.state_form$.company_id.$error,
                    "validation-errors": _ctx.state_form$.company_id.$errors,
                    "error-text": "При получении списка компаний произошла ошибка",
                    "search-by": "name",
                    "select-by": "id",
                    label: "name",
                    "infinite-scroll": "",
                    onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
                    onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (
                            _ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)
                        )),
                    onSearch: _ctx.searchCompany,
                    onOptionBySearch: _ctx.unshiftFindedCompany,
                    class: "mt-3"
                  }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_the_input, {
                      value: _ctx.state.full_address,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.full_address) = $event)),
                      disabled: "",
                      class: "w-3/5",
                      placeholder: "Адрес",
                      "is-invalid": _ctx.state_form$.full_address.$error,
                      "validation-errors": _ctx.state_form$.full_address.$errors
                    }, null, 8, ["value", "is-invalid", "validation-errors"]),
                    _createVNode(_component_the_button, {
                      class: "mt-2 ml-3 primary text small w-2/5",
                      onClick: _ctx.onStartGeocode
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode(" Указать ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_the_time, {
                      value: _ctx.state.work_time_from,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.work_time_from) = $event)),
                      "is-invalid": _ctx.state_form$.work_time_from.$error,
                      "validation-errors": _ctx.state_form$.work_time_from.$errors,
                      placeholder: "Начало работы с 00:00"
                    }, null, 8, ["value", "is-invalid", "validation-errors"]),
                    _createVNode(_component_the_time, {
                      value: _ctx.state.work_time_until,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.work_time_until) = $event)),
                      "is-invalid": _ctx.state_form$.work_time_until.$error,
                      "validation-errors": _ctx.state_form$.work_time_until.$errors,
                      class: "ml-3",
                      placeholder: "Конец работы в 00:00"
                    }, null, 8, ["value", "is-invalid", "validation-errors"])
                  ]),
                  _createVNode(_component_the_textarea, {
                    value: _ctx.state.description,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.description) = $event)),
                    class: "mt-1",
                    autoheight: "",
                    rows: 4,
                    placeholder: "Описание"
                  }, null, 8, ["value"]),
                  _createVNode(_component_checkbox, {
                    value: _ctx.state.is_active,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.is_active) = $event)),
                    "return-integer": "",
                    class: "mt-1",
                    label: "Активен"
                  }, null, 8, ["value"])
                ])),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_the_button, {
                class: "primary text small",
                loading: _ctx.state.is_loading,
                onClick: _ctx.clickHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isAddUser
                                ? 'Привязать пользователя'
                                : _ctx.isCreate
                                ? 'Добавить'
                                : 'Сохранить данные'), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_page_title, {
              title: `${_ctx.isAddUser ? 'Укажите адрес' : 'Привязать пользователя к ПВЗ'}`
            }, null, 8, ["title"]),
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.emitCancel
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_geocoder, {
              city: _ctx.state.city,
              latitude: _ctx.state.latitude,
              longitude: _ctx.state.longitude,
              "full-address": _ctx.state.full_address,
              onSetAddress: _ctx.onSetAddress
            }, null, 8, ["city", "latitude", "longitude", "full-address", "onSetAddress"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_the_button, {
                class: "primary text small",
                loading: _ctx.state.is_loading,
                onClick: _ctx.addAddress
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ]))
  ]))
}